module.exports = __webpack_public_path__ + "img/location.6bd44b23.svg";